import React from 'react';
import { Link } from 'react-router-dom';
import './UserDepositTemplate.scss';

const UserDepositTemplate = ({ balance, history, historyCount, page, limit, onPageChange }) => {
  const totalPages = Math.ceil(historyCount / limit);

  const getTypeLabel = (type) => {
    const typeMap = {
      deposit: '입금',
      withdraw: '출금',
      use: '사용',
    };
    return typeMap[type] || type;
  };

  const formatAmount = (amount, type) => {
    const sign = type === 'deposit' ? '+' : '-';
    return `${sign}${Number(amount).toLocaleString()}원`;
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString('ko-KR');
  };

  const handlePageClick = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      onPageChange(newPage);
    }
  };

  return (
    <div className="UserDepositTemplate">
      <div className="deposit-header">
        <h1 className="deposit-title">예치금</h1>
      </div>

      <div className="balance-card">
        <div className="balance-label">현재 예치금 잔액</div>
        <div className="balance-value">{Number(balance).toLocaleString()}원</div>
      </div>

      <div className="history-section">
        <h2 className="history-title">예치금 히스토리</h2>
        <div className="history-table-wrapper">
          <table className="history-table">
            <thead>
              <tr>
                <th>거래일시</th>
                <th>거래 유형</th>
                <th>금액</th>
                <th>거래 후 잔액</th>
                <th>주문 ID</th>
                <th>메모</th>
              </tr>
            </thead>
            <tbody>
              {history.length === 0 ? (
                <tr>
                  <td colSpan="6" className="empty-message">
                    거래 내역이 없습니다.
                  </td>
                </tr>
              ) : (
                history.map((item) => (
                  <tr key={item.id}>
                    <td>{formatDate(item.created_at)}</td>
                    <td>
                      <span className={`type-badge type-${item.type}`}>
                        {getTypeLabel(item.type)}
                      </span>
                    </td>
                    <td className={item.type === 'deposit' ? 'amount-positive' : 'amount-negative'}>
                      {formatAmount(item.amount, item.type)}
                    </td>
                    <td>{Number(item.balance_after).toLocaleString()}원</td>
                    <td>
                      {item.order_id ? (
                        <Link to={`/orders/${item.order_id}`} className="order-link">
                          {item.order_id}
                        </Link>
                      ) : (
                        '-'
                      )}
                    </td>
                    <td>{item.memo || '-'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="pagination">
            <button
              className="pagination-btn"
              onClick={() => handlePageClick(page - 1)}
              disabled={page === 1}
            >
              이전
            </button>
            <span className="pagination-info">
              {page} / {totalPages}
            </span>
            <button
              className="pagination-btn"
              onClick={() => handlePageClick(page + 1)}
              disabled={page === totalPages}
            >
              다음
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDepositTemplate;



// WEBPACK FOOTER //
// ./src/components/user/UserDepositTemplate/UserDepositTemplate.js